import { render, staticRenderFns } from "./relatedBy.vue?vue&type=template&id=1e11118d&scoped=true"
import script from "./relatedBy.vue?vue&type=script&lang=js"
export * from "./relatedBy.vue?vue&type=script&lang=js"
import style0 from "./relatedBy.vue?vue&type=style&index=0&id=1e11118d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e11118d",
  null
  
)

export default component.exports